(() => {
  // Previous/next buttons for a native scroll-snap row. Without JS the row still scrolls by touch, trackpad or keyboard.
  function init(root = document) {
    root.querySelectorAll('[data-hb-rail]').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const track = rail.querySelector('[data-hb-rail-track]');
      const prev = rail.querySelector('[data-hb-rail-prev]');
      const next = rail.querySelector('[data-hb-rail-next]');
      if (!track || !prev || !next) return;
      const step = () => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
        prev.parentElement.hidden = max <= 1;
      };
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const move = direction => track.scrollBy({ left: direction * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, { passive: true });
      const resize = 'ResizeObserver' in window ? new ResizeObserver(sync) : null;
      resize?.observe(track);
      sync();
      const unload = event => {
        if (!event.target.contains(rail)) return;
        resize?.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
